import ActionBar from './ActionBar'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import List from './List'
import {pageRequest, addItemtoPOForm, showConfirmSubmitModal} from 'actions/inventory/purchaseOrder'
import {connect} from 'react-redux'
import PurchaseOrderDetail from './PurchaseOrderDetail'
import FormPurchaseOrder from './FormPurchaseOrder/FormPurchaseOrder'
import ModalAddItem from './ModalAddItem/ModalAddItem'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {browserHistory} from 'react-router'
import {askConfirmAction} from 'actions/confirm-action'
import {push} from 'react-router-redux'
import {getFormValues, isDirty} from 'redux-form'
import ConfirmSubmitModal from './FormPurchaseOrder/ConfirmSubmitModal'
import NoDataAndLoading from 'components/NoDataAndLoading'

class PurchaseOrder extends React.Component {
  render () {
    const {openRightColumn, purchaseOrderDetail, rightColumnState, showModalItem, purchaseOrders, showLoadingSpinnerPage} = this.props
    return (<PageWrapper>
      <ActionBar />
      <ContentWrapper>
        <LeftColumnWrapper openRightColumn={openRightColumn}>
          <NoDataAndLoading
            showLoadingSpinner={showLoadingSpinnerPage}
            noDataToDisplay={purchaseOrders.length === 0}
            title='No Data To Display'
            description='' />
          <List />
        </LeftColumnWrapper>
        <RightColumnWrapper openRightColumn={openRightColumn}>
          {rightColumnState === 'detail' && purchaseOrderDetail && <PurchaseOrderDetail />}
          {rightColumnState === 'form' && <FormPurchaseOrder onSubmit={this._onFormSubmit} />}
          {rightColumnState === 'form' && showModalItem && <ModalAddItem onSubmit={this._onModalSubmit} />}
        </RightColumnWrapper>
      </ContentWrapper>
      <ConfirmActionModal />
      <ConfirmSubmitModal />
    </PageWrapper>)
  }
  _onModalSubmit = (itemVariantValue) => {
    const {dispatch, formPO, search: {namespace}} = this.props
    dispatch(addItemtoPOForm(itemVariantValue, formPO.itemPurchase, namespace))
  }
  _onFormSubmit = (values) => {
    this.props.dispatch(showConfirmSubmitModal(values.action))
  }
  componentDidMount () {
    const {dispatch, expired} = this.props
    if (!expired) {
      dispatch(pageRequest())
      browserHistory.listenBefore((location) => {
        const {isDirtyPO, nextAction} = this.props
        if (isDirtyPO && !nextAction) {
          dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }
}

function mapStateToProps (state) {
  const {expired} = state.subscriptionExpired
  const {openRightColumn, purchaseOrderDetail, rightColumnState, showModalItem, purchaseOrders} = state.inventory.purchaseOrder
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    openRightColumn,
    purchaseOrderDetail,
    rightColumnState,
    showModalItem,
    nextAction: state.confirmAction.nextAction,
    formPO: getFormValues('purchaseOrder')(state),
    isDirtyPO: isDirty('purchaseOrder')(state),
    search: getFormValues('search')(state),
    expired,
    purchaseOrders,
    showLoadingSpinnerPage
  }
}

function mapDispatchToProps (dispatch) {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrder)



// WEBPACK FOOTER //
// ./app/pages/Inventory/PurchaseOrder/PurchaseOrder.js